export const GPS_TYPE_TO_LABEL: Record<GPSType, string> = {
  INTERNAL: "Interne",
  UBUDU: "Ubudu",
};

export const GPS_STATUS_TO_LABEL: Record<GPSStatus, string> = {
  CONNECTING: "Connexion",
  CONNECTED: "Connecté",
  DISCONNECTED: "Déconnecté",
  ERROR: "Erreur",
};
